import { useEffect } from "react";
import { useBrand } from "@aviv-unified-frontend/runtime/brand";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { useLocation } from "@aviv-unified-frontend/runtime/router";

import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { isIOSSafari } from "../../../../utils/isIOSSafari";

const KEY = "custom-banner";
const EXCLUDED_APPS = ["app_serp_map", "app_esfu_estimaLandingPage"];

export const useInitCustomBanner = () => {
  const { id: brandId } = useBrand();

  const {
    application: { id: applicationId },
  } = useEnvironment();

  const { search } = useLocation();
  const { dispatch } = useOverlayOrchestrator();
  const canProceed = useOverlayStepsOrchestrator(KEY);

  useEffect(() => {
    if (!canProceed) return;

    const isDisabled =
      !applicationId ||
      !BRAND_CONFIGURATION.appBanner?.custom?.[applicationId] ||
      EXCLUDED_APPS.includes(applicationId) ||
      /**
       * The banner must not be displayed on the Classified Details Page (CDP) for users on iOS mobile Safari to avoid conflicts with App Clips.
       * Or when the user arrived via the "Meine Stadt SERP" IWT campaign to prevent overlapping promotional content.
       */
      (applicationId === "app_cldp" &&
        (isIOSSafari() ||
          (brandId === "iwt" && search.includes("utm_source=meine"))));

    if (isDisabled) {
      dispatch({ type: "DISABLE", payload: KEY });

      return;
    }

    dispatch({ type: "INIT", payload: KEY });
  }, [applicationId, brandId, canProceed, search, dispatch]);
};
